import textHelper from '@/core/mixins/textHelper';

export default {
  campaignListHeaders: [
    {
      key: 'expand',
      label: '',
      width: '5%',
    },
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      tdClass: 'text-wrap',
    },
    {
      key: 'state',
      label: 'State',
      width: '8%',
      formatter: (value) => (['LIVE', 'PAUSED', 'DORMANT', 'REVIEW', 'ENDED']
        .includes(value) ? textHelper.methods.capitalize(value) : 'Draft'),
    },
    {
      key: 'startDate',
      label: 'Start',
      sortable: true,
      width: '8%',
      sortByFormatted: false,
    },
    {
      key: 'endDate',
      label: 'End',
      sortable: true,
      width: '8%',
      sortByFormatted: false,
    },
    {
      key: 'budget',
      label: 'Budget Spent',
      width: '20%',
      tdClass: 'budget-cell',
    },
    {
      key: 'impressions',
      label: 'Impressions',
      width: '10%',
    },
  ],
  actionsHeader: [
    {
      key: 'action',
      label: 'actions',
      width: '4%',
    },
  ],
  suppressedList: [
    {
      key: 'clicks', label: 'Total Clicks', width: '8%',
    },
    {
      key: 'ctr',
      label: 'CTR%',
      width: '8%',
      formatter: (value) => {
        if (value === null) return '';
        return `${value}%`;
      },
    },
  ],
  managedCampaignsList: [
    {
      key: 'accountManager',
      label: 'AM',
    },
  ],
  manageTrackersListHeaders: [
    {
      key: 'creativeId',
      label: 'CREATIVE',
      sortable: true,
      tdClass: 'text-wrap',
    },
    {
      key: 'publisherCode',
      label: 'PUBLISHER',
      sortable: true,
      tdClass: 'text-wrap',
    },
    {
      key: 'countryCode',
      label: 'COUNTRIES',
      sortable: true,
      tdClass: 'text-wrap',
    },
    {
      key: 'geoCodes',
      label: 'GEO Groups',
      sortable: true,
      tdClass: 'text-wrap',
    },
    {
      key: 'impressionTracker',
      label: 'IMPRESSION',
      sortable: true,
      tdClass: 'text-wrap',
      width: '120px',
    },
    {
      key: 'clickTracker',
      label: 'CLICK',
      sortable: true,
      tdClass: 'text-wrap',
      width: '120px',
    },
    {
      key: 'postClickTracker',
      label: 'POST CLICK',
      sortable: true,
      tdClass: 'text-wrap',
      width: '120px',
    },
    {
      key: 'thirdPartyTags',
      label: '3RD PARTY TAGS',
      sortable: true,
      tdClass: 'text-wrap',
      width: '120px',
    },
    {
      key: 'actions',
      label: 'Actions',
    },
  ],
  sharedCampaignListHeaders: [
    {
      key: 'expand',
      label: '',
      width: '5%',
    },
    {
      key: 'name',
      label: 'Campaign',
      sortable: true,
      tdClass: 'text-wrap',
    },
    {
      key: 'state',
      label: 'State',
      width: '8%',
      formatter: (value) => (['LIVE', 'PAUSED', 'DORMANT', 'REVIEW', 'ENDED']
        .includes(value) ? textHelper.methods.capitalize(value) : 'Draft'),
    },
    {
      key: 'startDate',
      label: 'Start',
      sortable: true,
      width: '8%',
      sortByFormatted: false,
    },
    {
      key: 'endDate',
      label: 'End',
      sortable: true,
      width: '8%',
      sortByFormatted: false,
    },
    {
      key: 'budget',
      label: 'Progress',
      width: '20%',
      tdClass: 'budget-cell',
    },
    {
      key: 'impressions',
      label: 'Impressions',
      width: '10%',
    },
  ],
};
